import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  Format,
  KnockoutCompetition,
  RoundRobinCompetition,
  SeasonData,
  SeasonDataSansCompetitions,
} from '@pool-league/shared-data-api';
import { HttpErrorResponse } from '@angular/common/http';

export const routerActions = createActionGroup({
  source: 'router',
  events: {
    'season opened': props<{ seasonSlug: string }>(),
    'season closed': emptyProps(),
  },
});

export const seasonApiActions = createActionGroup({
  source: 'season API',
  events: {
    'season loaded': props<{ season: SeasonData }>(),
    'season load error': props<{
      seasonSlug: string;
      error: HttpErrorResponse | Error;
    }>(),
    'season status updated': props<{ season: SeasonDataSansCompetitions }>(),
    'transition status error': props<{ error: HttpErrorResponse | Error }>(),
  },
});

export const seasonInfoComponentActions = createActionGroup({
  source: 'season info component',
  events: {
    'transition status': emptyProps(),
  },
});

// TODO: This feels like it's in the wrong place - move to cup state?
export const cupOverviewComponentActions = createActionGroup({
  source: 'cup overview component',
  events: {
    'cup created': props<{
      details: KnockoutCompetition;
      format: Format;
      seasonId: string;
    }>(),
    'cup status updated': props<{
      details: KnockoutCompetition;
      format: Format;
      seasonId: string;
    }>(),
    'entrants updated': props<{
      entrants: string[];
      format: Format;
      seasonId: string;
    }>(),
  },
});

// TODO: This feels like it's in the wrong place - move to league state?
export const leagueOverviewComponentActions = createActionGroup({
  source: 'league overview component',
  events: {
    'league created': props<{
      format: Format;
      seasonId: string;
      details: RoundRobinCompetition;
    }>(),
    'league status updated': props<{
      format: Format;
      seasonId: string;
      details: RoundRobinCompetition;
    }>(),
  },
});
